export type { UseNavigateToMenuProps } from './useNavigateToMenu';
export { useNavigateToMenu } from './useNavigateToMenu';
